<div class="w-full max-w-120 sm:w-120 mx-auto sm:mx-0">
  <!-- Title -->
  <div class="mt-8 text-4xl font-extrabold tracking-tight leading-tight text-white">{{'Register' | transloco}}
  </div>
  <div class="flex items-baseline mt-0.5 font-medium text-white ">
    <div>{{'Create a new account today' | transloco}}</div>
  </div>

  <!-- Alert -->
  <fuse-alert class="mt-8" *ngIf="showAlert" [appearance]="'outline'" [showIcon]="false" [type]="alert.type"
    [@shake]="alert.type === 'error'">
    {{alert.message}}
  </fuse-alert>

  <!-- Sign Up form -->
  <form class="mt-8" [formGroup]="signUpForm" #signUpNgForm="ngForm">


    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <!-- Name field -->
      <mat-form-field class="w-full">
        <mat-label class="text-white">{{'Firstname' | transloco}}</mat-label>
        <input id="firstname" matInput [formControlName]="'firstname'">
        <mat-error *ngIf="signUpForm.get('firstname').hasError('required')">
          {{'Firstname is required' | transloco}}
        </mat-error>
      </mat-form-field>
      <mat-form-field class="w-full">
        <mat-label class="text-white">{{'Lastname' | transloco}}</mat-label>
        <input id="lastname" matInput [formControlName]="'lastname'">
        <mat-error *ngIf="signUpForm.get('lastname').hasError('required')">
          {{'Lastname is required' | transloco}}
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Email field -->
    <mat-form-field class="w-full">
      <mat-label class="text-white">{{'Phone' | transloco}}</mat-label>
      <input id="phone" matInput [formControlName]="'phone'">
      <mat-error *ngIf="signUpForm.get('phone').hasError('required')">
        {{'Field is required' | transloco}}
      </mat-error>
    </mat-form-field>

    <!-- Email field -->
    <mat-form-field class="w-full">
      <mat-label class="text-white">{{'Email address' | transloco}}</mat-label>
      <input id="email" matInput [formControlName]="'email'">
      <mat-error *ngIf="signUpForm.get('email').hasError('required')">
        {{'Email address is required' | transloco}}
      </mat-error>
      <mat-error *ngIf="signUpForm.get('email').hasError('email')">
        {{'Please enter a valid email address' | transloco}}
      </mat-error>
    </mat-form-field>

    <!-- Password field -->
    <mat-form-field class="w-full">
      <mat-label class="text-white">{{'Password' | transloco}}</mat-label>
      <input id="password" matInput type="password" [formControlName]="'password'" #passwordField>
      <button mat-icon-button type="button"
        (click)="passwordField.type === 'password' ? passwordField.type = 'text' : passwordField.type = 'password'"
        matSuffix>
        <mat-icon class="icon-size-5" *ngIf="passwordField.type === 'password'"
          [svgIcon]="'heroicons_solid:eye'"></mat-icon>
        <mat-icon class="icon-size-5" *ngIf="passwordField.type === 'text'"
          [svgIcon]="'heroicons_solid:eye-off'"></mat-icon>
      </button>
      <mat-error>
        {{'Password is required' | transloco}}
      </mat-error>
    </mat-form-field>

    <!-- ToS and PP -->
    <div class="flex flex-col items-end w-full mt-1.5">

      <mat-checkbox class="-ml-2 border-white mb-2" [color]="'primary'"
        style="--mdc-checkbox-unselected-icon-color: #FFFFFF;--mdc-checkbox-unselected-focus-icon-color:#ffffff;--mdc-checkbox-unselected-ripple-color:#ffffff;"
        [formControlName]="'agreements_phone'">
        <span class="text-white">
          {{'I agree that when sending telephone contact, it is accessible in case of sending an advertisement' |
          transloco}}
        </span>
      </mat-checkbox>
      <mat-checkbox class="-ml-2 border-white" [color]="'primary'"
        style="--mdc-checkbox-unselected-icon-color: #FFFFFF;--mdc-checkbox-unselected-focus-icon-color:#ffffff;--mdc-checkbox-unselected-ripple-color:#ffffff;"
        [formControlName]="'agreements'">
        <span class="text-white">{{'I agree with' | transloco}}</span>
        <a class="ml-1 text-primary-500 hover:underline" [routerLink]="['./']">
          {{'Terms' | transloco}}
        </a>
        <span class="text-white">{{'and' | transloco}}</span>
        <a class="ml-1 text-primary-500 hover:underline" [routerLink]="['./']">
          {{'Privacy Policy' | transloco}}
        </a>
      </mat-checkbox>
    </div>

    <!-- Submit button -->
    <button class="fuse-mat-button-large w-full mt-6 rounded-none" mat-flat-button [color]="'primary'"
      [disabled]="signUpForm.disabled || signUpForm.invalid" (click)="signUp()">
      <span *ngIf="!signUpForm.disabled">
        {{'Create your free account' | transloco}}
      </span>
      <mat-progress-spinner *ngIf="signUpForm.disabled" [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
    </button>

  </form>
</div>